import { applyDisplayEmptyPageRelocation } from '../../utils/applyDisplayEmptyPageRelocation';
import { navigateToPage } from './navigateToPage';
import type { OnNextRunState } from './types';

/**
 * Current page has no visible questions (display logic).
 * Jump to the next visible page or submit if the survey path is complete.
 */
export function tryLeaveEmptyPage(run: OnNextRunState): boolean {
  if (run.currentQuestions.length > 0) {
    return false;
  }

  const relocation = applyDisplayEmptyPageRelocation(
    run.refs,
    run.pages,
    run.currentPageIndex,
    run.logicContext
  );

  if (relocation?.action === 'submit') {
    void run.onSubmit();
    return true;
  }

  if (relocation?.action === 'navigate') {
    navigateToPage(run, relocation.pageIndex);
    return true;
  }

  return false;
}
